import { render, staticRenderFns } from "./UpcomingServices.vue?vue&type=template&id=1891c53a&scoped=true&"
import script from "./UpcomingServices.vue?vue&type=script&lang=js&"
export * from "./UpcomingServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1891c53a",
  null
  
)

export default component.exports